import React from 'react';
import ReactDOM from 'react-dom';
import {GetCurrentLocale} from "../../components/Utils";
import t from "../../components/I18N/TranslateHelpers";
import {useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";

interface ComponentProps {
  isShowing: boolean,
  hide: any
}

const Modal = ({isShowing, hide} : ComponentProps) => {
  const locale = GetCurrentLocale();
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )
  const closeModal = () => {
    hide();
  }

  return isShowing ? ReactDOM.createPortal(
    <>
      <div className="modal-backdrop fade show"/>
      <div className="modal modal-cart fade show" id="modaleOfferRequest"  tabIndex={-1} role="dialog" aria-hidden="true" aria-labelledby="modalOfferRequest" aria-modal="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body nopadding">
              <div className="row nopadding nomargin">
                <div className="justify-content-end d-flex">
                  <button type="button" className="close-modale" data-bs-dismiss="modal" onClick={() => closeModal()}>
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="col-md-6 bg-header-nopadding bg-primary text-white py-5 px-5">
                  <div className="flex-column py-5 align-items-center d-flex ">
                    <h5 className="card-title text-white">{t('continue')}</h5>
                    <p className="text-center">{t('select_product_before_offer')}</p>
                    <button type="button" className="btn btn-light-outline-white" data-bs-dismiss="modal" onClick={() => closeModal()}>
                      {t('continue')}
                    </button>
                  </div>
                </div>
                <div className="col-md-6 flex-column py-5 px-5 text-center">
                  <div className="py-5">
                    <h5 className="card-title">{t('make_request')}</h5>
                    <p className="text-center">{t('make_products_request')}</p>
                    <a href={
                      itemsInCart && itemsInCart.items && itemsInCart.items.length > 0
                        ?
                        "/" + locale + t('url_cart')
                        :
                        "/" + locale + t('url_request_offer')
                    } className="btn btn-outline-primary margintopauto">
                      {t('ask')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>, document.body
  ) : null;
}
export default Modal;
